import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const EmbedRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = location.search;
    navigate(`/embed/${searchParams}`, { replace: true });
  }, [location, navigate]);

  return null;
};

export default EmbedRedirect;
